export default {
  getUserProjects: (state) => state.userProjects,
}